import { h, JSX } from "preact";

import RawColor from "../../../foundation/api/model/colors/RawColor";
import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./ColorSquaredDot.module.css";

type NativeButtonProps = JSX.HTMLAttributes<HTMLButtonElement>;

interface Props extends NativeButtonProps {
    style?: CSSProperties;
    color?: string;
    rgbaColor?: RawColor;
    size?: number;
    outline?: boolean;
}

function ColorSquaredDot({
    class: cssClass,
    style,
    color,
    rgbaColor,
    size,
    outline,
    ...nativeButtonProps
}: Props) {
    const colorDotStyle: CSSProperties = style ?? {};

    if (color) {
        colorDotStyle["--color-dot-bg-color"] = color;
    }

    if (rgbaColor) {
        colorDotStyle["--color-dot-bg-color"] = `rgba(${rgbaColor.r}, ${rgbaColor.g}, ${rgbaColor.b}, ${rgbaColor.a})`;
    }

    if (size) {
        colorDotStyle["--color-dot-size"] = `${size}px`;
    }

    return (
        <button
            {...nativeButtonProps}
            class={classname(styles.colorSquaredDot, cssClass, {
                [styles.outline]: outline
            })}
            style={colorDotStyle}>
        </button>
    );
}

export default ColorSquaredDot;
